import React from 'react';
import { PropTypes } from 'prop-types';
import { Box, Typography } from '@mui/material';
import ChartHeader from './ChartHeader';
import ChartSubtitle from './ChartSubtitle';

const ChartContainer = ({
    children,
    subtitle,
    title,
    subtitleProps,
    flex = '0 1 40%',
    ...rest
}) => {
    return (
        <Box height="100%" display="flex" flexDirection="column" alignItems="center" flex={flex}>
            {!!title && <ChartHeader title={title} {...rest} />}
            {children}
            {!!subtitle && (
                <Typography variant="subtitle2" align="center">
                    {subtitle}
                </Typography>
            )}
            {!!subtitleProps && <ChartSubtitle {...subtitleProps} />}
        </Box>
    );
};

ChartContainer.propTypes = {
    subtitle: PropTypes.string,
    subtitleProps: PropTypes.object,
    children: PropTypes.node.isRequired,
    useSymbol: PropTypes.bool,
    handleClick: PropTypes.func,
    number: PropTypes.number,
    title: PropTypes.string,
    flex: PropTypes.string,
};

export default ChartContainer;
